<template>
  <div>
    <div class="table-column">
      <div class="row pt-12">
        <div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 pl-21 pt-4 pb-4">
          <span class="activity-text">Activities</span>
        </div>
      </div>
      <div class="wrapper">
        <div>
          <table class="table">
            <thead class="table-border">
              <tr>
                <th :class="[field.class, field.key]" v-for="(field, index) in activityFields" :key="index">
                  <span class="pr-3 position-relative" :class="[field.extra]" @click="sortList(field)">
                    {{ field.label }}
                    <span class="sortUp" :class="{ 'disable-icon': !field.ascOrder }"><i class="fa fa-angle-up" aria-hidden="true"></i></span>
                    <span class="sortDown" :class="{ 'disable-icon': !field.descOrder }"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(activity, index) in selectedActivities" :key="index">
                <td class="pl-21 delete">
                  <span @click="deleteActivity(index)"><i class="fa fa-trash"></i></span>
                </td>
                <td class="pl-21 name" :title="activity.taskTitle">
                  {{ activity.taskTitle }}
                </td>
                <td class="type" :title="activity.taskType">
                  {{ activity.taskType }}
                </td>
                <td class="schedule" v-if="isScheduleColDisplay" :title="activity.schedule">
                  <span class="schedule-text" v-if="activity.type && activity.type === 'schedule'">Scheduled to send</span>
                  <span class="schedule-text" v-else-if="activity.type && activity.type === 'sendNow'">Send now</span>
                  <button v-else class="schedule-btn" @click="scheduleActivities(activity)">
                    Schedule
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="btn-wrapper">
            <button class="btn cancel-btn" @click="cancelScheduling()">
              Cancel
            </button>
            <button class="btn send-btn" @click="sendScheduledActivities()" v-if="isScheduleColDisplay" :disabled="disableSendBtn">
              Send
            </button>
            <button class="btn send-btn" @click="sendPreScreenedActivityBtn()" v-if="!isScheduleColDisplay">
              Send Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import toastr from "toastr";
import _ from "lodash";
export default {
  name: "ActivitySelectorComponent",
  props: {
    selectedActivityList: {
      type: Array,
      required: true
    },
    scheduledActivityData: {
      type: Object,
      required: true,
      default: () => {}
    },
    participantData: {
      type: Object,
      required: true,
      default: () => {}
    },
    isManualStudyStart: {
      type: Boolean
    },
    participantStudyTrigger: {
      type: Boolean
    },
    studyVersionId: {
      type: String
    },
    studyData: {
      type: Object
    }
  },
  data() {
    return {
      activityFields: [
        {
          key: "trash",
          ascOrder: false,
          descOrder: false,
          label: "",
          class: "pl-21",
          currentOrder: null,
          extra: "trash-additional"
        },
        {
          key: "taskTitle",
          ascOrder: false,
          descOrder: false,
          label: "Name",
          class: "pl-21",
          currentOrder: null
        },
        {
          key: "taskType",
          ascOrder: false,
          descOrder: false,
          label: "Type",
          class: "pl-10"
        },
        {
          key: "type",
          ascOrder: false,
          descOrder: false,
          label: "Schedule",
          class: "pl-10"
        }
      ],
      selectedActivities: [],
      typeAlias: {
        survey: "Survey",
        epro: "ePRO",
        activity: "eDRO",
        telehealth: "Telehealth"
      },
      disableSendBtn: true,
      isScheduleColDisplay: false,
      isPreScreenedFlag: false
    };
  },
  watch: {
    selectedActivityList: {
      deep: true,
      immediate: true,
      handler(newData) {
        this.selectedActivities = newData;
        this.$forceUpdate();
      }
    },
    scheduledActivityData: function(newData) {
      const data = newData;
      if (data) {
        if (data.setScheduleForAllActivities) {
          /* Set this scheduler to all selected activities */
          const allActivities = [];
          this.selectedActivities.forEach(activity => {
            allActivities.push({ ...data.scheduler, ...activity });
          });
          // eslint-disable-next-line no-unused-vars
          const a = allActivities.map(({ participantId, studyId, ...rest }) => rest);
          this.selectedActivities = a;
        } else {
          /* Set this scheduler to only this selected activity */
          const index = this.selectedActivities.findIndex(a => a.taskId === data.activity.taskId);
          if (index > -1) {
            this.selectedActivities[index] = data.activity;
          }
        }
        this.$forceUpdate();
        this.checkSendBtnStatus();
      }
    }
  },
  mounted() {
    /* this.getActivityList(); */
    if (this.isManualStudyStart && !this.participantStudyTrigger) {
      this.activityFields = this.activityFields.filter(item => item.label != "Schedule");
      this.isScheduleColDisplay = false;
    } else {
      this.isScheduleColDisplay = true;
    }
  },

  methods: {
    scheduleActivities(activity) {
      this.$emit("sendSelectedActivity", { activity: activity });
    },
    showNumberOfRecords() {
      this.currentPage = 1;
      this.getActivityList();
    },
    sendScheduledActivities() {
      this.disableSendBtn = true;
      const screeningActivities = _.cloneDeep(this.selectedActivities);
      const queryParam = {
        studyId: this.$route.params.studyId,
        participantId: this.$route.params.participantId,
        versionId: this.selectedActivities[0].studyVersionId,
        participantCurrentDay: this.participantData.participantDetails.participantCurrentDay,
        languageId: this.participantData.participantDetails.participant.participantLanguage.language_id
      };
      if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
        screeningActivities.forEach((activity, i) => {
          if (activity.duration && activity.duration.length) {
            activity.duration.forEach((days, j) => {
              this.selectedActivities[i].duration[j].startDay = Number(days.startDay) + this.studyData.screeningDuration;
              this.selectedActivities[i].duration[j].endDay = Number(days.endDay) + this.studyData.screeningDuration;
            });
          }
        });
      }
      const postData = this.selectedActivities.filter(a => {
        if (a && a.type && (a.type === "sendNow" || a.type === "schedule") && (a.completedBy == null || a.completedBy == undefined) && (a.taskType.toLowerCase() == "survey" || a.taskType.toLowerCase() == "epro" || a.taskType.toLowerCase() == "activity" || a.taskType.toLowerCase() == "telehealth")) {
          return true;
        }
        if (a && a.type && (a.type === "sendNow" || a.type === "schedule") && !!a.completedBy && (a.completedBy.includes("Observer/Caregiver") || a.completedBy.includes("Patient/Participant"))) {
          return true;
        }
      });
      const sitePostData = this.selectedActivities.filter(a => {
        if (a && a.type && (a.type === "sendNow" || a.type === "schedule") && a.taskType.toLowerCase() == "packet") {
          return true;
        }
        if (a && a.type && (a.type === "sendNow" || a.type === "schedule") && !!a.completedBy && a.completedBy.indexOf("Observer/Caregiver") === -1 && a.completedBy.indexOf("Patient/Participant") === -1) {
          return true;
        }
      });
      if (postData && postData.length) {
        this.$api.sendJITActivities(queryParam, postData).then(
          () => {
            this.$emit("cancelScheduling", { showDoubleConfirmation: false });
          },
          err => {
            toastr.error(err && err.body.message);
            if (postData && postData.length == 1) {
              this.$emit("cancelScheduling", { showActivityList: true });
            } else {
              this.disableSendBtn = false;
            }
          }
        );
      }
      if (sitePostData && sitePostData.length) {
        this.$api.sendJITSiteActivities(queryParam, sitePostData).then(
          () => {
            this.$emit("cancelScheduling", { showDoubleConfirmation: false });
          },
          err => {
            toastr.error(err && err.body.message);
            if (sitePostData && sitePostData.length == 1) {
              this.$emit("cancelScheduling", { showActivityList: true });
            } else {
              this.disableSendBtn = false;
            }
          }
        );
      }
    },
    sendPreScreenedActivityBtn() {
      swal({
        title: "You are sending activities to a participant who has not started the study. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B8C7CE",
        cancelButtonColor: "#34537D",
        confirmButtonText: "No",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          const queryParam = {
            studyId: this.$route.params.studyId,
            participantId: this.$route.params.participantId,
            versionId: this.studyVersionId,
            languageId: this.participantData.participantDetails.participant.participantLanguage.language_id
          };
          const postData = this.selectedActivities;
          postData.map(item => (item["taskInstanceId"] = item.taskId));
          // postData[0]['taskInstanceId'] = this.selectedActivities[0].taskId;
          this.$api.sendPreScreenedActivity(queryParam, postData).then(
            data => {
              localStorage.setItem("isPreScreenedFlag", true);
              this.$emit("cancelScheduling", { showDoubleConfirmation: false });
              if (data.body.message == "This activity has already been sent to the participant. Activities may only be sent once to a participant prior to study start.") {
                toastr.warning(data.body.message);
              }
            },
            err => {
              toastr.error(err && err.body.message);
              if (postData && postData.length == 1) {
                this.$emit("cancelScheduling", { showActivityList: true });
              } else {
                this.disableSendBtn = false;
              }
            }
          );
        }
      });
    },
    deleteActivity(index) {
      swal({
        title: "Are you sure you would like to delete this activity?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B8C7CE",
        cancelButtonColor: "#34537D",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.selectedActivities.splice(index, 1);
          if (this.selectedActivities && !this.selectedActivities.length) {
            this.$emit("showAllActivities");
          }
          this.checkSendBtnStatus();
        }
      });
    },
    cancelScheduling() {
      this.$emit("cancelScheduling", { showDoubleConfirmation: true });
    },
    printTypeAlias(activity) {
      const type = activity.taskType;
      for (const prop in this.typeAlias) {
        if (type === prop) {
          return this.typeAlias[prop];
        }
      }
    },
    checkSendBtnStatus() {
      this.disableSendBtn = true;
      //Enable Send button only when all selected activities are scheduled
      let activitiesToSend = [];
      activitiesToSend = this.selectedActivities.filter(activity => {
        return activity.completionWindow;
      });
      if (activitiesToSend.length == this.selectedActivities.length) {
        this.disableSendBtn = false;
      }
    },
    sortList(field) {
      this.sortValue = field.key;
      field.ascOrder = !field.ascOrder;
      if (field.ascOrder) {
        this.sortOrder = "asc";
        field.descOrder = false;
      } else {
        field.descOrder = true;
        this.sortOrder = "desc";
      }

      //Reset sort flags for other keys
      this.activityFields.map(field => {
        if (field.key != this.sortValue) {
          field.ascOrder = false;
          field.descOrder = false;
        }
      });

      this.currentPage = 1;
      this.sortActivityList(this.sortValue, this.sortOrder);
    },
    sortActivityList(sortBy, sortOrder) {
      const activities = this.selectedActivities;
      const sort = (data, prop) => {
        if (data[prop]) {
          return data[prop].toLowerCase();
        } else {
          return "z";
        }
      };
      this.selectedActivities = _.orderBy(activities, [activity => sort(activity, sortBy)], [sortOrder]);
    },
    getPreScreenedActivityCheck() {
      this.$api.getPreScreenedActivityCheck(this.$route.params.studyId, this.$route.params.participantId).then(
        response => {
          if (response.body) {
            this.isPreScreenedFlag = response.body;
          }
          localStorage.setItem("isPreScreenedFlag", response.body);
        },
        error => {
          const err = error.body && error.body.message ? error.body.message : "Error while getting pre screened activity flag";
          this.$toastr.error(err);
        }
      );
    }
  }
};
</script>
/*
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style> */
<style lang="scss" scoped>
.table {
  margin-bottom: 0;
  margin-top: 5px;
  color: #4a4a4a;
  border-bottom: 1px solid #e4e8eb;

  thead {
    border: 1px solid #e4e8eb;
    border-right: 0;
    border-left: 0;
    &.table-border {
      border-top: 0;
    }
    th {
      color: #9b9b9b !important;
      border-top: none;
      border-bottom: none;
      vertical-align: top;
      font-weight: bold;
      font-size: 12px;
      background: rgba(249, 249, 251, 0.2);
      padding-top: 6px;
      padding-bottom: 6px;
      span {
        cursor: pointer;
      }
    }
  }

  tbody tr {
    border-bottom: none;
    td {
      padding: 12px 10px 12px;
      &.delete {
        padding: 12px 0px 12px;
        span {
          width: 20.7px;
          height: 21.7px;
          position: relative;
          display: inline-block;
          border-radius: 2px;
          border: 1px solid #d8d8d8;
          background-color: #d3dfe4;
          i {
            color: #acb5b9;
            position: absolute;
            top: 2.5px;
            left: 3.5px;
          }
        }
        &:hover {
          cursor: pointer;
        }
        &:after {
          font-size: 11px !important;
          font-weight: 100 !important;
        }
      }
      .schedule-btn {
        padding: 6px 16px 6px;
        border-radius: 3px;
        border: solid 2px #d3dfe4;
        background-color: #fff;
        color: #4c8ce4;
        font-family: RobotoRegular;
        font-size: 12px;
        font-weight: normal;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .schedule-text {
      font-family: RobotoRegular;
      font-size: 14px;
      font-weight: normal;
      color: #48bf7a;
    }
  }

  th,
  td {
    padding: 10px;
    word-break: break-all;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &.trash {
      width: 44px;
      padding-right: 0px;
      .trash-additional {
        visibility: hidden;
      }
    }
    &.name {
      max-width: 130px;
      color: #666669;
    }
    &.type {
      max-width: 140px;
      color: #666669;
    }
  }

  tr.active {
    border: solid 1px #e4e8eb;
    background-color: rgba(211, 222, 227, 0.2);
  }
}

.table-column {
  background-color: #fff;
  border: solid 1px #e4e8eb;
  border-radius: 4px;
  font-family: "Roboto-Regular", sans-serif;
  /*  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06); */
}

.select_control {
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
}

.gridHead {
  margin-top: -7px;
}

.wrapper {
  overflow-x: hidden;
}

@media (max-width: 1199px) {
  .has-sidemenu .container {
    padding-left: 30px !important;
    padding-right: 30px !important;
    width: auto;
    max-width: inherit;
  }
}

.sortDown {
  position: absolute;
  margin-left: 5px;
  margin-top: 3px;
}

.sortUp {
  position: absolute;
  margin-top: -4px;
  margin-left: 5px;
}

.sortUp,
.sortDown {
  cursor: pointer;
  color: #666769;
  &.disable-icon {
    color: #a8a8a8;
  }
  i {
    font-size: 11px;
  }
}

.activity-text {
  font-family: "RobotoRegular";
  font-size: 15px;
  font-weight: 600 !important;
  color: #2d3752;
}
.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  margin: 0 -5%;
  overflow: hidden;
}
.btn-wrapper {
  float: right;
  margin: 21px 24px 18px 10px;
  border: unset !important;
  width: unset !important;
  .btn {
    padding: 7px 31px;
    font-family: "RobotoRegular";
    font-size: 14px;
    color: #4a4a4a;
    outline: none;
    &:hover {
      cursor: pointer;
    }
    &:active {
      outline: none;
      cursor: pointer;
    }
    &:disabled {
      opacity: 0.5;
    }
    &.cancel-btn {
      margin-right: 13px;
      background-color: #fff;
      border: 1px solid #e4e8eb;
    }
    &.send-btn {
      background-color: #4c8ce4;
      color: #fff;
      &:disabled {
        cursor: not-allowed;
      }
    }
  }
}
</style>
